//HOW TO ADD A NEW LOC CONTEXT
// 1. Add a new context to the LocContext enum
// 2. Add a new file in the localization/sources/nb folder with the name of the context
// 3. Add the context to the getSourceMap.tsx file and import the new file added in step 2
// 4. Add the context to the generateTranslationSources.ts file
// 5. Add the context to the getTranslationMap.tsx file
// 6. Make sure you have something to translate in the new context.
// If you try to run the command below without any text to translate, the .json translation files will be empty and react will throw an error.
// 7. Finally run this command to generate the rest of the translation files:
// OPENAI_API_KEY=<secret> npm run translate

export enum LocContext {
  JOBS = "JOBS",
  JOB = "JOB",
  GENERAL = "GENERAL",
  PROFILE = "PROFILE",
  CV = "CV",
  ADMIN = "ADMIN",
  WORKSCHEDULE = "WORKSCHEDULE",
  TIMESHEETS = "TIMESHEETS",
  MESSAGES = "MESSAGES",
  PRIME = "PRIME",
  PRIVACY = "PRIVACY",
  ERROR = "ERROR",
  TYPES = "TYPES",
}
